export const VENDOR = 'vendor'
export const SME = 'subject_matter_expert'
export const TA = 'teacher_assistant'
export const ADMIN = 'admin'

export const ALL = [VENDOR, SME, TA, ADMIN]
